import {
  faClipboardCheck,
  faThumbsUp,
} from '@fortawesome/pro-duotone-svg-icons';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  EmptyState,
  EmptyStateContainer,
  EmptyStateIcon,
} from 'components/atoms/empty-state';
import { useNotificationsDrawer } from 'components/organisms/notifications/drawer/hash-based-notifications';

interface NoResultEmptyStateProps {
  onSecondaryClick: () => void;
}

export const NoResultEmptyState: FC<NoResultEmptyStateProps> = ({
  onSecondaryClick,
}) => (
  <EmptyStateContainer>
    <EmptyState
      image={<EmptyStateIcon icon={faClipboardCheck} />}
      title={<FormattedMessage id="home.no_results.empty.title" />}
      message={<FormattedMessage id="home.no_results.empty.message" />}
      secondaryCTA={
        <EmptyState.CallToAction.Secondary onClick={onSecondaryClick}>
          <FormattedMessage id="home.no_results.empty.secondary" />
        </EmptyState.CallToAction.Secondary>
      }
    />
  </EmptyStateContainer>
);

export const InCompleteTasksEmptyState = () => {
  const [[drawerState], show, hide] = useNotificationsDrawer();

  return (
    <EmptyStateContainer>
      <EmptyState
        image={<EmptyStateIcon icon={faThumbsUp} />}
        title={<FormattedMessage id="home.incomplete.empty.title" />}
        message={<FormattedMessage id="home.incomplete.empty.message" />}
        secondaryCTA={
          <EmptyState.CallToAction.Secondary
            onClick={() => {
              if (drawerState === 'show') {
                hide();
              } else {
                show();
              }
            }}
          >
            <FormattedMessage id="home.incomplete.empty.secondary" />
          </EmptyState.CallToAction.Secondary>
        }
      />
    </EmptyStateContainer>
  );
};
